import React from 'react'
import {LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend} from 'recharts';
import {firestore} from '../../firebase/firebase.utils'
class Graph extends React.Component{
    constructor(){
        super();
        this.state = {
            date: '',
            value:'',
            data : []
        }
    }
    handleDate = (event) =>{
        this.setState({date:event.target.value})
    }
    handleValue = (event) =>{
        this.setState({value:event.target.value})
    }
    onSubmit = () => {
        const that = this
    //   firestore.collection("graph").add({
    //     date: that.state.date,
    //     value: that.state.value
    // })
    // .then(function(docRef) {
    //     console.log("Document written with ID: ", docRef.id);
    //     that.onLoad();
    // })
    // .catch(function(error) {
    //     console.error("Error adding document: ", error);
    // });
    let arr = []
    if(this.state.data.length>0){
    for(let i=0;i<this.state.data.length;i++){
        arr[i] = this.state.data[i]
    }
    }
    arr.push({
        date: that.state.date,
        value: that.state.value
    })
    // console.log(arr);
    firestore.collection("graph").doc("0UGZ4uG4oHgdti0HOrZ7").set({
        data : arr
    })
    .then(() => {
        console.log("Document successfully written!");
    })
    .catch((error) => {
        console.error("Error writing document: ", error);
    });
    }
    onLoad(){
      let c = []
      const that = this
    //   firestore.collection("graph")
    // .get()
    // .then(function(querySnapshot) {
    //     querySnapshot.forEach(function(doc) {
    //       c.push(doc.data())
    //     });
    //     that.setState({data:c})
    //     console.log(c);
    // })
    // .catch(function(error) {
    //     console.log("Error getting documents: ", error);
    // });

    firestore.collection("graph").doc("0UGZ4uG4oHgdti0HOrZ7").get().then((doc) => {
        c.push(doc.data())
        that.setState({data:c[0].data})
        // console.log(c[0].data);
}).catch((error) => {
    console.log("Error getting document:", error);
});
    }
    componentDidMount(){
        this.onLoad();
    }
	render () {
        if(this.props.route==='admin'){
            return (
                <div className= "ba bw2 b--black tc flex flex-column items-center">
                    <input 
                    type='text'
                    className='pa3 ba ma2 b--green bg-lightest-blue' 
                    placeholder='Enter Date'
                    onInput = {this.handleDate}
                    />
                    <input 
                    type='number'
                    className='pa3 ba ma2 b--green bg-lightest-blue' 
                    placeholder='Enter Value'
                    onInput = {this.handleValue}
                    />
                    <input
                        onClick={this.onSubmit}
                        className="b ph3 pv2 pr4 input-reset ba b--white white bg-transparent grow pointer f6 dib"
                        type="submit"
                        value="Enter Value"
                      />
                    <LineChart className="pa4 ma4 bg-near-white" width={850} height={500}  data={this.state.data}
                        margin={{top: 5, right: 30, left: 20, bottom: 5}}>
                <XAxis dataKey="date"/>
                <YAxis/>
                <CartesianGrid strokeDasharray="3 3"/>
                <Tooltip/>
                <Legend />
                <Line type="monotone" dataKey="value" stroke="#8884d8" activeDot={{r: 8}}/>
        
                </LineChart>
              </div>
            );
        }
        else{
            return(
              <div className="ba bw2 b--black tc flex flex-column items-center"> 
              <LineChart className=" pa4 ma4 bg-near-white" width={850} height={500} data={this.state.data}
                margin={{top: 5, right: 30, left: 20, bottom: 5}}>
        <XAxis dataKey="date"/>
        <YAxis/>
        <CartesianGrid strokeDasharray="3 3"/>
        <Tooltip/>
        <Legend />
        <Line type="monotone" dataKey="value" stroke="#8884d8" activeDot={{r: 8}}/>

        </LineChart>
        </div>
      
    );
            
        }
  	
  }
}
export default Graph;

